import ActionTypes from '../../constants/ActionTypes'

const initialState = {
  user: {
    isLoggedIn: false,
    firstName: '',
    lastName: '',
    userName: '',
    numberOfOrderItems: 0,
    email: '',
    telenorNalogId: '',
    wishlist: []
  },
  flashMessages: [],
  gtmData: {
    gtmUserId: '',
    gtmAgentType: ''
  },
  redirectUser: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SESSION_DATA.SET :
      return action.payload;
    case ActionTypes.SESSION_DATA.REMOVE :
      return state
    default:
      return state;
  }
}
